"use strict";

var _toConsumableArray = require("/var/www/html/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
function getRange(start, end) {
  return _toConsumableArray(Array(end - start + 1)).map(function (_, i) {
    return start + i;
  });
}
exports.getRange = getRange;
function getPageInfo(params) {
  var limit = params.limit,
    pageCount = params.pageCount,
    total = params.total,
    page = params.page;
  var totalPages = Math.ceil(total / limit);
  var totalResults = total;
  var currentPage = page;
  if (currentPage < 1) {
    currentPage = 1;
  }
  if (currentPage > totalPages) {
    currentPage = totalPages;
  }
  var firstPage = Math.max(1, currentPage - Math.floor(pageCount / 2));
  var lastPage = Math.min(totalPages, currentPage + Math.floor(pageCount / 2));
  if (lastPage - firstPage + 1 < pageCount) {
    if (currentPage < totalPages / 2) {
      lastPage = Math.min(totalPages, lastPage + (pageCount - (lastPage - firstPage)));
    } else {
      firstPage = Math.max(1, firstPage - (pageCount - (lastPage - firstPage)));
    }
  }
  if (lastPage - firstPage + 1 > pageCount) {
    if (currentPage > totalPages / 2) {
      firstPage = firstPage + 1;
    } else {
      lastPage = lastPage - 1;
    }
  }
  var pages = Math.min(lastPage - firstPage + 1, totalPages);
  var previousPage = currentPage - 1;
  var nextPage = currentPage + 1;
  var hasPreviousPage = currentPage > 1;
  var hasNextPage = currentPage < totalPages;
  var firstResult = limit * (currentPage - 1);
  var lastResult = limit * currentPage - 1;
  var results = Math.min(lastResult - firstResult + 1, totalResults);
  return {
    totalPages: totalPages,
    pages: pages,
    currentPage: currentPage,
    firstPage: firstPage,
    lastPage: lastPage,
    previousPage: previousPage,
    nextPage: nextPage,
    hasPreviousPage: hasPreviousPage,
    hasNextPage: hasNextPage,
    totalResults: totalResults,
    results: results,
    firstResult: firstResult,
    lastResult: lastResult
  };
}
exports.getPageInfo = getPageInfo;